import axios from "axios";
import { APP_SETTINGS } from '../../config';

export function getAllLeavesType() {
    return axios.get(APP_SETTINGS.API_PATH.LEAVES.LEAVESTYPE.getAllLeavesType)
}
export function getAllLeavesRequest(requestId, token) {
    return axios.post(APP_SETTINGS.API_PATH.ATTENDANCE.leaveRequests, { requestId }, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
}
export function updateLeaveRequestStatus(leaveStatus, token) {
    return axios.post(APP_SETTINGS.API_PATH.LEAVES.updateLeaveRequestStatus, leaveStatus, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
}